import {Component, input, output} from '@angular/core';

@Component({
  selector: 'toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.css'],
  standalone: false
})
export class ToastComponent {
  message = input.required<string>();
  type = input<'success' | 'error' | 'info'>('info');
  closeToast = output();

  close() {
    this.closeToast.emit();
  }
}
